import { RackMaterial, ShelfDeck } from '../types/configurator';

export const SECTIONS_LEVEL_COUNTS = [2, 3, 4, 5, 6, 7, 8];
export const SIDES_DISTANCE = 100;
export const BORDER_WIDTH = 62;
export const SIDE_BORDER_WIDTH = 36;
export const LARGE_BORDER_WIDTH = 85;
export const END_STAND_WIDTH = 4;
export const FREESTANDING_SECTIONS_WIDTH = 40;
export const FRONT_SECTION_TOOLS_HEIGHT = 110;
export const FRONT_SECTION_TOOLS_GAP = 20;
export const SIDE_EDITOR_TOOLS_HEIGHT = 80;
export const SIDE_EDITOR_TOOLS_GAP = 20;
export const BOTTOM_SHELF_DISTANCE = 150;
export const TOP_SHELF_DISTANCE = 100;
export const TOP_BRACE_MARGIN = 50;
export const SHELF_CHUNKS_COUNT = 9;
export const SHELF_HEIGHT = 76.2;

export const RACK_MATERIAL_COLORS: Record<RackMaterial, string> = {
	[RackMaterial.ZN]: '#ACACAC',
	[RackMaterial.RAL_2004]: '#43474D',
};
export const RACK_BORDER_MATERIAL_COLORS: Record<RackMaterial, string> = {
	[RackMaterial.ZN]: '#B0B0B0',
	[RackMaterial.RAL_2004]: '#DE6116',
};
export const SHELVE_MATERIAL_COLORS: Record<ShelfDeck, string> = {
	[ShelfDeck.GALVANIZED_METAL]: '#C0C0C0',
	[ShelfDeck.PAINTED_METAL]: '#474A50',
	[ShelfDeck.SANDED_PARTICLE_BOARD]: '#A67C52',
	[ShelfDeck.LAMINATED_PARTICLE_BOARD]: '#D9E7FC',
};
export const SHELVE_MATERIALS_LIMITS: Record<RackMaterial, ShelfDeck[]> = {
	[RackMaterial.ZN]: [ShelfDeck.GALVANIZED_METAL, ShelfDeck.SANDED_PARTICLE_BOARD],
	[RackMaterial.RAL_2004]: [ShelfDeck.PAINTED_METAL, ShelfDeck.LAMINATED_PARTICLE_BOARD],
};
export const MODULAR_SHELVES = [ShelfDeck.GALVANIZED_METAL, ShelfDeck.PAINTED_METAL];
export const MAX_SHELF_WEIGHT = {
	1340: 900,
	1720: 550,
	2100: 400,
	2480: 300,
};
export const SHELF_DECK = [
	{
		paramsLabel: 'sectionParams.shelfParams.galvanizedMetal',
		label: 'material.shelf.galvanizedMetal',
		value: ShelfDeck.GALVANIZED_METAL,
	},
	{
		paramsLabel: 'sectionParams.shelfParams.paintedMetal',
		label: 'material.shelf.paintedMetal',
		value: ShelfDeck.PAINTED_METAL,
	},
	{
		paramsLabel: 'sectionParams.shelfParams.sandedParticleBoard',
		label: 'material.shelf.sandedParticleBoard',
		value: ShelfDeck.SANDED_PARTICLE_BOARD,
	},
	{
		paramsLabel: 'sectionParams.shelfParams.laminatedParticleBoard',
		label: 'material.shelf.laminatedParticleBoard',
		value: ShelfDeck.LAMINATED_PARTICLE_BOARD,
	},
];
export const RACK_MATERIALS_OPTIONS = [
	{
		label: 'material.rack.zinc',
		value: RackMaterial.ZN,
		image: 'materials/zinc.png',
	},
	{
		label: 'material.rack.ral2004',
		value: RackMaterial.RAL_2004,
		image: 'materials/ral2004.png',
	},
];
